var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6048 5.375H23.7648V6.745C23.7648 7.295 23.3148 7.745 22.7648 7.745C22.2148 7.745 21.7648 7.295 21.7648 6.745V5.375H17.1447C17.3647 6.135 17.4847 6.945 17.4847 7.775C17.4847 8.565 17.3747 9.325 17.1747 10.055H26.5048V22.995C26.5048 24.445 25.3248 25.625 23.8748 25.625H9.61475C8.19475 25.625 7.04477 24.475 7.04477 23.055V16.185C6.55477 16.075 6.08477 15.935 5.63477 15.745V23.675C5.63477 25.505 7.11476 26.985 8.94476 26.985H24.5948C26.4248 26.985 27.9048 25.505 27.9048 23.675V8.685C27.9048 6.855 26.4248 5.375 24.5948 5.375H24.6048Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87491 15.2256C4.68491 15.2256 1.2749 11.8156 1.2749 7.62563C1.2749 5.65563 2.0249 3.78562 3.3949 2.35563C3.6149 2.13563 3.96491 2.12563 4.18491 2.33563C4.40491 2.54563 4.4149 2.90563 4.2049 3.12563C3.0449 4.33563 2.40491 5.93563 2.40491 7.61563C2.40491 11.1856 5.31492 14.0956 8.88492 14.0956C12.4549 14.0956 15.3649 11.1856 15.3649 7.61563C15.3649 4.04563 12.4549 1.13563 8.88492 1.13563C7.98492 1.13563 7.1149 1.31563 6.3049 1.67563C6.0249 1.79563 5.68491 1.67563 5.56491 1.38563C5.44491 1.10563 5.56492 0.765626 5.85492 0.645626C6.81492 0.225626 7.83492 0.015625 8.88492 0.015625C13.0749 0.015625 16.4849 3.42563 16.4849 7.61563C16.4849 11.8056 13.0749 15.2156 8.88492 15.2156L8.87491 15.2256Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84521 6.29633C3.53521 6.29633 3.28522 6.04633 3.28522 5.73633V3.10633H0.655212C0.345212 3.10633 0.0952148 2.85633 0.0952148 2.54633C0.0952148 2.23633 0.345212 1.98633 0.655212 1.98633H3.85522C4.16522 1.98633 4.41522 2.23633 4.41522 2.54633V5.74633C4.41522 6.05633 4.16522 6.30633 3.85522 6.30633L3.84521 6.29633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87494 11.3548C8.56494 11.3548 8.31494 11.1048 8.31494 10.7948V7.58477C8.31494 7.45477 8.35494 7.33476 8.43494 7.23477L11.8949 2.92477C12.0849 2.68477 12.4449 2.64477 12.6849 2.83477C12.9249 3.02477 12.9649 3.38476 12.7749 3.62476L9.43494 7.77476V10.7848C9.43494 11.0948 9.18494 11.3448 8.87494 11.3448V11.3548Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74487 7.62586C9.74487 8.10586 9.35488 8.49586 8.87488 8.49586C8.39488 8.49586 8.00488 8.10586 8.00488 7.62586C8.00488 7.14586 8.39488 6.75586 8.87488 6.75586C9.35488 6.75586 9.74487 7.14586 9.74487 7.62586Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 17.207H10.665V19.467H12.925V17.207Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5852 17.207H14.3252V19.467H16.5852V17.207Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 17.207H17.9849V19.467H20.2449V17.207Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.905 17.207H21.645V19.467H23.905V17.207Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 21.6953H10.665V23.9553H12.925V21.6953Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5852 21.6953H14.3252V23.9553H16.5852V21.6953Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 21.6953H17.9849V23.9553H20.2449V21.6953Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.905 21.6953H21.645V23.9553H23.905V21.6953Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 13.0762H17.9849V15.3362H20.2449V13.0762Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.905 13.0762H21.645V15.3362H23.905V13.0762Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7748 7.12578C22.5648 7.12578 22.4048 6.95578 22.4048 6.75578V3.04578C22.4048 2.83578 22.5748 2.67578 22.7748 2.67578C22.9748 2.67578 23.1448 2.84578 23.1448 3.04578V6.75578C23.1448 6.96578 22.9748 7.12578 22.7748 7.12578Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.8d5807b50960c4266042f505e1f0103d.svg";
export { ForwardRef as ReactComponent };